import { useState } from "react";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom";
import logo from "../img/katsina_state_logo.png";
import { useJwt } from "react-jwt";

const NavBar = ({ setAboutUsModal, setContactUsModal, homePage }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const token = localStorage.getItem("access_token");
  const { decodedToken } = useJwt(token);
  const isLoggedIn = !!(decodedToken?.sub && token && token !== "null");

  const handleLogOut = () => {
    localStorage.removeItem("access_token");
    window.location.href = "/";
  };

  return (
    <nav className="bg-white border-b border-gray-100 sticky top-0 z-40">
      <div className="w-full px-6 flex items-center h-16">

        {/* Logo — far left */}
        <Link to="/" className="flex items-center gap-2 no-underline flex-shrink-0">
          <img src={logo} alt="Katsina State" className="h-10 w-10 object-contain" />
          <div className="leading-tight">
            <div className="text-green-700 font-bold text-sm">Katsina State</div>
            <div className="text-red-500 text-xs">Sustainable Development Goals</div>
          </div>
        </Link>

        {/* Desktop nav links — centered */}
        <div className="hidden md:flex flex-1 items-center justify-center gap-10">
          <NavLink to="/" label="Home" />
          <button
            onClick={() => window.location.replace("/#about")}
            className="text-gray-700 text-sm font-medium hover:text-gray-900 border-b-2 border-transparent hover:border-gray-800 pb-0.5 transition-all bg-transparent border-0 outline-none cursor-pointer"
          >
            About Us
          </button>
          <NavLink to="/login" label="SDGs" />
          {decodedToken?.role === "superAdmin" && (
            <NavLink to="/admin" label="Admin" />
          )}
        </div>

        {/* Sign in / Log out — far right */}
        <div className="hidden md:flex items-center flex-shrink-0 ml-auto">
          {isLoggedIn ? (
            <button
              onClick={handleLogOut}
              className="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors"
            >
              Log out
            </button>
          ) : (
            <Link to="/login" className="no-underline">
              <button className="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors">
                Sign in
              </button>
            </Link>
          )}
        </div>

        {/* Mobile hamburger — far right on small screens */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2 ml-auto"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <span className={`block w-5 h-0.5 bg-gray-700 transition-all ${mobileOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-5 h-0.5 bg-gray-700 transition-all ${mobileOpen ? "opacity-0" : ""}`} />
          <span className={`block w-5 h-0.5 bg-gray-700 transition-all ${mobileOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile dropdown */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-3">
          <Link to="/" className="text-gray-700 text-sm font-medium no-underline" onClick={() => setMobileOpen(false)}>Home</Link>
          <button
            className="text-left text-gray-700 text-sm font-medium bg-transparent border-0 outline-none cursor-pointer p-0"
            onClick={() => { window.location.replace("/#about"); setMobileOpen(false); }}
          >
            About Us
          </button>
          <Link to="/login" className="text-gray-700 text-sm font-medium no-underline" onClick={() => setMobileOpen(false)}>SDGs</Link>
          {decodedToken?.role === "superAdmin" && (
            <Link to="/admin" className="text-purple-700 text-sm font-semibold no-underline" onClick={() => setMobileOpen(false)}>Admin</Link>
          )}
          <div className="pt-2 border-t border-gray-100">
            {isLoggedIn ? (
              <button onClick={handleLogOut} className="w-full bg-green-600 text-white text-sm font-semibold px-4 py-2 rounded-full">
                Log out
              </button>
            ) : (
              <Link to="/login" className="no-underline" onClick={() => setMobileOpen(false)}>
                <button className="w-full bg-green-600 text-white text-sm font-semibold px-4 py-2 rounded-full">
                  Sign in
                </button>
              </Link>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

function NavLink({ to, label }) {
  const location = useLocation();
  const isActive = location.pathname === to;
  return (
    <Link
      to={to}
      className={`text-sm font-medium no-underline border-b-2 pb-0.5 transition-all ${
        isActive
          ? "text-gray-900 border-gray-900"
          : "text-gray-700 border-transparent hover:text-gray-900 hover:border-gray-800"
      }`}
    >
      {label}
    </Link>
  );
}

export default NavBar;
